import { createContext, useContext } from "react";

/** Type for the data provided by the network connect context provider */

/** Network connection context definition */
export const NetworkConnectionContext = createContext(undefined);

/**
 * Custom hook to access the network connection data.
 *
 * @throws {Error} when this custom hook is not used inside NetworkConnectionProvider
 */
export function useNetworkConnectionContext() {
  const context = useContext(NetworkConnectionContext);
  if (!context) {
    throw Error("useNetworkConnectionContext() must be used inside the NetworkConnectionProvider component");
  }
  return context;
}